/***
 * @author Leonel Martinez 
 * @fileoverview eStore exposed APIs services list
 */
export const API = {
  VEHICLE: {
    YEARS: `vehicle/years`,
    MAKES: `vehicle/makes`,
    MODELS: `vehicle/models`,
    ENGINES: `vehicle/engines`,
    VEHICLES_LIST: `vehicle/vehicles`,
    CREATE: `vehicle/vehicles`,
    UPDATE: `vehicle/vehicles`,
  },
  CATEGORIES_TREE: `categories-tree`,
  POWERBOX: {
    VEHICLES: `elasticsearch/ymme?q=`,
    PARTS: `elasticsearch/parts?q=`,
    P2V: `plate2vin/ymme?q=`
  },
  INQUIRY: `gms/inquiry`,
  INTERCHANGE: `interchange-search`,
  C2C: {
    URL: `c2c`,
    THUMBNAIL: `thumbnail`
  },
  UNIQUE_DESCRIPTIONS: `unique-descriptions` 
};
